import { apiCall } from "../helpers/api";

export const usercvs =
    (params = {}) =>
        (dispatch) => {
            params.path = params.path || "user-cvs";
            return dispatch(apiCall(params));
        };
